import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";

import NothingFoundAnimation from "../../../assets/animation/nothing-found.json";

import { Button } from "@/components/ui/button";

const NoSummary: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='flex flex-col items-center justify-center'>
      <Lottie
        animationData={NothingFoundAnimation}
        style={{
          width: 400,
        }}
        autoPlay
        loop
      />
      <h1 className='mb-4 text-3xl font-medium'>No summary to show</h1>
      <p>
        It seems like there are no summary reports to show, please consider
        adding day reports to generate summary.
      </p>
      <Button
        className='mt-4'
        onClick={() => navigate("/reports/daily-reports/form")}
      >
        Add Day Report
      </Button>
    </div>
  );
};

export default NoSummary;
